import React, { useState } from 'react';
import PropTypes from 'prop-types';

function RelatorioProdutividade({ atendimentos }) {
  const [periodo, setPeriodo] = useState('mensal'); // 'semanal' ou 'mensal'

  // Agrupar atendimentos por clínica
  const produtividadePorClinica = atendimentos.reduce((acc, atendimento) => {
    const chave = atendimento.clinica;

    if (!acc[chave]) {
      acc[chave] = {
        nome: chave,
        totalAtendimentos: 0,
        totalTempo: 0,
        mediaAtendimentos: 0,
      };
    }

    acc[chave].totalAtendimentos += 1;

    return acc;
  }, {});

  // Transformar em array e calcular média de atendimentos
  const produtividadeArray = Object.values(produtividadePorClinica).map(
    (clinica) => {
      const totalPeriodos = periodo === 'mensal' ? 4 : 52; // Aproximadamente 4 semanas por mês ou 52 semanas por ano
      return {
        ...clinica,
        mediaAtendimentos: (clinica.totalAtendimentos / totalPeriodos).toFixed(
          2
        ),
      };
    }
  );

  return (
    <div className="bg-white shadow-lg p-8 mb-8 rounded-2xl">
      <h3 className="text-2xl font-bold mb-6 text-gray-900">
        Relatório de Produtividade por Clínica
      </h3>

      <div className="mb-4">
        <label
          htmlFor="periodo"
          className="block text-sm font-medium text-gray-700"
        >
          Período
        </label>
        <select
          id="periodo"
          value={periodo}
          onChange={(e) => setPeriodo(e.target.value)}
          className="mt-2 block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        >
          <option value="semanal">Semanal</option>
          <option value="mensal">Mensal</option>
        </select>
      </div>

      {/* Tabela com responsividade */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
          <thead className="bg-blue-100">
            <tr>
              <th className="py-3 px-4 text-left text-gray-700 font-bold">
                Clínica
              </th>
              <th className="py-3 px-4 text-left text-gray-700 font-bold">
                Total de Atendimentos
              </th>
              <th className="py-3 px-4 text-left text-gray-700 font-bold">
                Média de Atendimentos (
                {periodo === 'mensal' ? 'por Mês' : 'por Semana'})
              </th>
            </tr>
          </thead>
          <tbody>
            {produtividadeArray.map((clinica) => (
              <tr
                key={clinica.nome}
                className="border-b hover:bg-blue-50 transition-colors duration-200"
              >
                <td className="py-3 px-4 text-gray-800 text-sm font-medium">
                  {clinica.nome}
                </td>
                <td className="py-3 px-4 text-gray-800 text-sm font-medium">
                  {clinica.totalAtendimentos}
                </td>
                <td className="py-3 px-4 text-gray-800 text-sm font-medium">
                  {clinica.mediaAtendimentos}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

RelatorioProdutividade.propTypes = {
  atendimentos: PropTypes.arrayOf(
    PropTypes.shape({
      clinica: PropTypes.string.isRequired,
      dataAtendimento: PropTypes.object.isRequired,
    })
  ).isRequired,
};

export default RelatorioProdutividade;
